// src/pages/CourseTime/utils/caseStudy.js

// Section id -> lc key of the section label (lc_vales_app.js, all six locales).
export const CASE_STUDY_LABEL_KEYS = {
  story: 'ct__case_the_story',
  meet: 'ct__case_meet',
  problem: 'ct__case_the_problem',
  choice: 'ct__case_the_choice',
  stopAndThink: 'ct__case_stop_and_think',
  risks: 'ct__case_what_could_go_wrong',
  whatHappened: 'ct__case_what_happened',
  bigIdea: 'ct__case_the_big_idea',
  itsLike: 'ct__case_its_like',
  letsTalk: 'ct__case_lets_talk',
};

// The content carries the choices without letters; the UI adds them.
export const CASE_STUDY_CHOICE_LETTERS = ['A', 'B', 'C'];

const cleanText = (value) => (typeof value === 'string' ? value.trim() : '');

const cleanList = (value) => (Array.isArray(value) ? value.map(cleanText).filter(Boolean) : []);

// (origin) => 1 | 2 | null
export const getCaseStudyPart = (origin) => {
  const part = Number(origin && origin.case_part);
  return part === 1 || part === 2 ? part : null;
};

// (slide, origin) => string
export const getCaseStudyTitle = (slide, origin) =>
  cleanText(origin && origin.case_title) || cleanText(slide && slide.SlideTitle);

// (text) => string[] — paragraphs are separated by a blank line
export const splitCaseStudyParagraphs = (text) =>
  (typeof text === 'string' ? text.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean) : []);

const textSection = (id, text) => (text ? [{ id, labelKey: CASE_STUDY_LABEL_KEYS[id], kind: 'text', text }] : []);

const listSection = (id, kind, items) => (items.length ? [{ id, labelKey: CASE_STUDY_LABEL_KEYS[id], kind, items }] : []);

const getPartOneSections = (origin) => {
  const name = cleanText(origin.character_name);
  const role = cleanText(origin.character_role);
  const goal = cleanText(origin.character_goal);
  const question = cleanText(origin.choice_question);
  const choices = cleanList(origin.choices);
  return [
    ...textSection('story', cleanText(origin.story)),
    ...(name || role || goal
      ? [{ id: 'meet', labelKey: CASE_STUDY_LABEL_KEYS.meet, kind: 'character', name, role, goal }]
      : []),
    ...textSection('problem', cleanText(origin.problem)),
    ...(question || choices.length
      ? [{
        id: 'choice',
        labelKey: CASE_STUDY_LABEL_KEYS.choice,
        kind: 'choice',
        question,
        // The contract has exactly 3 choices; any extra ones continue the alphabet.
        items: choices.map((text, index) => ({
          letter: CASE_STUDY_CHOICE_LETTERS[index] || String.fromCharCode(65 + index),
          text,
        })),
      }]
      : []),
    ...textSection('stopAndThink', cleanText(origin.stop_and_think)),
  ];
};

const getPartTwoSections = (origin) => [
  ...listSection('risks', 'list', cleanList(origin.risks)),
  ...textSection('whatHappened', cleanText(origin.what_happened)),
  ...textSection('bigIdea', cleanText(origin.big_idea)),
  ...textSection('itsLike', cleanText(origin.everyday_comparison)),
  ...listSection('letsTalk', 'numbered', cleanList(origin.discussion_questions)),
];

// (origin) => Section[] | null — null means "no structured fields": render the
// legacy case_snippet paragraphs instead.
export const getCaseStudySections = (origin) => {
  const part = getCaseStudyPart(origin);
  if (part === null) return null;
  const sections = part === 1 ? getPartOneSections(origin) : getPartTwoSections(origin);
  return sections.length ? sections : null;
};
